import { useState } from "react";
import editUserStatus from "../api/editUserStatus";

const UserChangeStatusPop = ({ user, toggleUserPop, setStatus }) => {
  const [userStatus, setUserStatus] = useState(1);
  const [changeStatus, setChangeStatus] = useState(user.status);
  const [textAlert, setTextAlert] = useState("");

  // handle Change Status
  const handleChangeUserStatus = async (e) => {
    e.preventDefault();
    const response = await editUserStatus({
      user_id: user.id,
      new_status: userStatus,
    });

    if (response) {
      setTextAlert(
        `تم تغيير حالة المستخدم الى حالة ( ${
          userStatus === 2 ? "مستخدم غير فعال" : "مستخدم فعال"
        } ) بنجاح`
      );
      setChangeStatus(true);
      setStatus(userStatus);
    }
  };

  return (
    <>
      <div className="fixed w-[45%] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 shadow-lg rounded-lg  border">
        <button
          className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
          onClick={() => toggleUserPop()}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </button>
        <div className="my-2">
          <h2 className="text-xl mb-4">
            <span className="underline text-blue-500 mx-4">{user.name}</span>
            تغيير الحالة للمستخدم
          </h2>
          <form className="flex flex-col items-end my-2" onSubmit={handleChangeUserStatus}>
            <div className="mb-2 w-full text-right">
              <label className="block mb-2 text-md">حالة المستخدم </label>
              <select
                className="w-full p-2 border rounded-lg mb-2"
                dir="rtl"
                value={userStatus}
                onChange={(e) => setUserStatus(Number(e.target.value))}
              >
                <option value="1">مستخدم فعال </option>
                <option value="2">مستخدم غير فعال</option>
              </select>
            </div>
            {changeStatus ? (
              <p className="w-full font-bold text-lg text-green-500 mb-2 flex items-center justify-center">
                {textAlert}
              </p>
            ) : (
              ""
            )}
            <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded-lg">
              تغير حالة المستخدم
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default UserChangeStatusPop;
